var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleLeftArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    transform: "rotate(180 8 8)",
    fill: "white",
    stroke: "#5E4DE0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.03125 5.35867L6.85792 7.53201C6.60125 7.78867 6.60125 8.20867 6.85792 8.46534L9.03125 10.6387",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03125 5.35867L6.85792 7.53201C6.60125 7.78867 6.60125 8.20867 6.85792 8.46534L9.03125 10.6387",
    stroke: "#5E4DE0",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleLeftArrow);
export default __webpack_public_path__ + "static/media/CircleLeftArrow.0b3aa4e57fabf7a46a3c509420e27445.svg";
export { ForwardRef as ReactComponent };